<div class="banner-wrapper">
    <div class="banner-box banner_{{type}}">
        <ng-content></ng-content>
    </div>
</div>
